// extracted by mini-css-extract-plugin
export default {"container":"PaginatedTable_component_container__bVpcv","containerSelectable":"PaginatedTable_component_containerSelectable__F-ngc"};